import { useQuery } from 'react-apollo';
import quickAccessBarQuery from './data/quickAccessBar.graphql';
const useQuickAccessBar = () => {
    const { loading, error, data: { quickAccessBar = [] } = {} } = useQuery(quickAccessBarQuery);
    return {
        error,
        loading,
        quickAccessBar,
    };
};
export { quickAccessBarQuery };
export default useQuickAccessBar;
